import React from "react";
import { Text } from "@merge-api/merge-javascript-shared";
import { UPDATED_COLUMN_CLASS } from "../constants";
import EmptyCellValue from "./EmptyCellValue";

interface Props {
  updatedAt: string | undefined;
}

const formatDate = (dateString: string) =>
  new Date(dateString).toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

const UpdatedCell = ({ updatedAt }: Props) => (
  <div role="cell" className={UPDATED_COLUMN_CLASS}>
    {updatedAt ? <Text>{formatDate(updatedAt)}</Text> : <EmptyCellValue />}
  </div>
);

export default UpdatedCell;
